export enum NavigationEnum {
    Home = 1,
    MyPolicies,
    CoverageOptions,
    CoverageAlerts,
    AboutUs,
    FAQ
  }
  